import NotificationApi from 'Api/Notification'
import moment from 'ct-moment'

export const actionTypes = {
  OPEN_TRAY: 'notificationTray/OPEN_TRAY',
  CLOSE_TRAY: 'notificationTray/CLOSE_TRAY',
  FETCH_NOTIFICATIONS_REQUEST: 'notificationTray/FETCH_NOTIFICATIONS_REQUEST',
  FETCH_NOTIFICATIONS_SUCCESS: 'notificationTray/FETCH_NOTIFICATIONS_SUCCESS',
  FETCH_MORE_NOTIFICATIONS_REQUEST: 'notificationTray/FETCH_MORE_NOTIFICATIONS_REQUEST',
  FETCH_MORE_NOTIFICATIONS_SUCCESS: 'notificationTray/FETCH_MORE_NOTIFICATIONS_SUCCESS',
  MARK_AS_READ_REQUEST: 'notificationTray/MARK_AS_READ_REQUEST',
  MARK_AS_READ_SUCCESS: 'notificationTray/MARK_AS_READ_SUCCESS',
  MARK_AS_UNREAD_REQUEST: 'notificationTray/MARK_AS_UNREAD_REQUEST',
  MARK_AS_UNREAD_SUCCESS: 'notificationTray/MARK_AS_UNREAD_SUCCESS',
  MARK_ALL_AS_READ_SUCCESS: 'notificationTray/MARK_ALL_AS_READ_SUCCESS',
  SET_ACTIVE_TAB: 'notificationTray/SET_ACTIVE_TAB',
}

const toggleTray = () => {
  return (dispatch, getState) => {
    const { isOpen } = getState().notificationTray

    dispatch(isOpen ? closeTray() : openTray())
  }
}

const openTray = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.OPEN_TRAY })
    dispatch(fetchNotifications())
  }
}

const closeTray = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CLOSE_TRAY })
  }
}

const fetchNotifications = (filter) => {
  return (dispatch, getState) => {
    const activeFilter = filter || getState().notificationTray.activeTab
    dispatch({ type: actionTypes.FETCH_NOTIFICATIONS_REQUEST })

    return new NotificationApi()
      .index(activeFilter, 1, 10)
      .then((res) => res.json())
      .then((data) => {
        const payload = {
          lastFetch: new moment(),
          notifications: data.notifications,
          currentPage: data.page,
          hasMore: data.has_more,
          totalCount: data.total_count,
        }
        if (activeFilter === 'unread') {
          payload.unreadTotalCount = data.total_count
        }
        dispatch({
          type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS,
          payload,
        })
      })
  }
}

const fetchMoreNotifications = () => {
  return (dispatch, getState) => {
    const { activeTab, currentPage, hasMore, isLoadingMore } = getState().notificationTray

    if (!hasMore || isLoadingMore) return Promise.resolve()

    dispatch({ type: actionTypes.FETCH_MORE_NOTIFICATIONS_REQUEST })

    return new NotificationApi()
      .index(activeTab, currentPage + 1, 10)
      .then((res) => res.json())
      .then((data) => {
        dispatch({
          type: actionTypes.FETCH_MORE_NOTIFICATIONS_SUCCESS,
          payload: {
            notifications: data.notifications,
            currentPage: data.page,
            hasMore: data.has_more,
          },
        })
      })
  }
}

const markAsRead = (id) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.MARK_AS_READ_REQUEST,
      payload: { id },
    })
    return new NotificationApi(id).markAsRead().then(() => {
      dispatch({
        type: actionTypes.MARK_AS_READ_SUCCESS,
        payload: { id },
      })
    })
  }
}

const markAsUnread = (id) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.MARK_AS_UNREAD_REQUEST,
      payload: { id },
    })
    return new NotificationApi(id).markAsUnread().then(() => {
      dispatch({
        type: actionTypes.MARK_AS_UNREAD_SUCCESS,
        payload: { id },
      })
    })
  }
}

const setActiveTab = (tab) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_ACTIVE_TAB, payload: tab })
    dispatch(fetchNotifications(tab))
  }
}

const markAllAsRead = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.MARK_ALL_AS_READ_SUCCESS })
    return new NotificationApi().markAllAsRead()
  }
}

export const actions = {
  openTray,
  closeTray,
  toggleTray,
  fetchNotifications,
  fetchMoreNotifications,
  markAsRead,
  markAsUnread,
  markAllAsRead,
  setActiveTab,
}
